var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"data-type":_vm.slide.type}},[_c('iframe',{attrs:{"src":_vm.slide.lien}})])}
var staticRenderFns = []

export { render, staticRenderFns }